import { render } from "./ResponsibleGamblingView.vue?vue&type=template&id=13404375&scoped=true"
import script from "./ResponsibleGamblingView.vue?vue&type=script&lang=js"
export * from "./ResponsibleGamblingView.vue?vue&type=script&lang=js"

import "./ResponsibleGamblingView.vue?vue&type=style&index=0&id=13404375&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13404375"]])

export default __exports__